(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customer-service-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const nav = document.querySelector('[data-cs-anchors]');
    if (!nav) return;

    const blocksContainer = nav.closest('.cs-layout__content')?.querySelector('.cs-layout__blocks');
    if (!blocksContainer) return;

    const blocks = blocksContainer.querySelectorAll('.cs-block[id]');
    const fragment = document.createDocumentFragment();

    blocks.forEach((block) => {
      const title = block.querySelector('.cs-block__title');
      if (!title || !title.textContent.trim()) return;

      const link = document.createElement('a');
      link.href = `#${block.id}`;
      link.className = 'theme-button secondary text-misc-14-100 hide-icon large';
      const labelSpan = document.createElement('span');
      labelSpan.className = 'theme-button__label';
      labelSpan.textContent = title.textContent.trim();
      link.appendChild(labelSpan);
      fragment.appendChild(link);
    });

    if (fragment.children.length > 0) {
      nav.appendChild(fragment);
      nav.removeAttribute('aria-hidden');
    } else {
      nav.hidden = true;
    }
    nav.classList.remove('cs-anchors--loading');
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["depict-patched-main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true },
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grid-selector"]) return;
  try {
    
  const source = document.querySelector('[data-products-count]');
  const display = document.querySelector('[data-products-count-display] span');

  if (source && display) {
    const update = () => {
      const count = source.dataset.productsCount;
      const current = display.textContent.match(/\d+/)?.[0];
      if (count !== current) {
        display.textContent =
          count > 25000
            ? display.textContent.replace(/[\d,]+/, '25,000')
            : display.textContent.replace(/[\d,]+/, Number(count).toLocaleString());
      }
    };

    new MutationObserver(update).observe(source, {
      attributes: true,
      attributeFilter: ['data-products-count'],
    });
  }

  /* `data-stuck` marks the moment the toolbar comes to rest under the header,
     which the header's own scroll flag can't stand in for — that one fires at
     the first pixel of scroll, long before the collection header has passed.
     Offset is always `--total-header-height` (the revealed position) so hiding
     the bar by changing `top` cannot flip this flag and start a loop. */
  const toolbar = document.querySelector('.grid-selector-wrapper');

  if (toolbar) {
    let observer;
    let observedOffset;
    const header = document.getElementById('header-component');

    const syncBarHeight = () => {
      toolbar.style.setProperty('--grid-selector-bar-height', `${toolbar.offsetHeight}px`);
    };

    const getHeaderOffset = () =>
      parseFloat(getComputedStyle(document.body).getPropertyValue('--total-header-height')) || 0;

    const syncInert = () => {
      const hidden = toolbar.hasAttribute('data-stuck') && header?.getAttribute('data-scroll-direction') === 'down';
      toolbar.toggleAttribute('inert', hidden);
    };

    const watchStuck = () => {
      const offset = getHeaderOffset();
      if (offset === observedOffset) return;
      observedOffset = offset;

      observer?.disconnect();
      observer = new IntersectionObserver(
        ([entry]) => {
          // The ratio drops below 1 at both ends of the viewport, so it only
          // means "stuck" once the toolbar is also up at its resting offset.
          const isStuck = entry.intersectionRatio < 1 && entry.boundingClientRect.top <= offset + 1;
          toolbar.toggleAttribute('data-stuck', isStuck);
          syncInert();
        },
        { threshold: [1], rootMargin: `-${offset + 1}px 0px 0px 0px` },
      );
      observer.observe(toolbar);
    };

    syncBarHeight();
    watchStuck();
    window.addEventListener(
      'resize',
      () => {
        syncBarHeight();
        watchStuck();
      },
      { passive: true },
    );

    if (header) {
      new MutationObserver(syncInert).observe(header, {
        attributes: true,
        attributeFilter: ['data-scroll-direction'],
      });
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"] && !Shopify.designMode) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true },
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
  function initPdpBuybox() {
    const section = document.querySelector('.pdp');
    if (!section) return;

    const pickers = section.querySelectorAll('variant-picker');
    const forms = section.querySelectorAll('product-form-component.pdp__form');
    if (!forms.length) return;

    const mobileBar = section.querySelector('.pdp__mobile-bar');
    const sheetSubmit = section.querySelector('.pdp__size-sheet-submit');
    const sheetLabelEl = sheetSubmit?.querySelector('.pdp__add-to-cart-label');
    const sheetPriceEl = sheetSubmit?.querySelector('.pdp__add-to-cart-price');

    function getCheckedRadio() {
      for (const p of pickers) {
        const checked = p.querySelector('input[type="radio"]:checked');
        if (checked) return checked;
      }
      return null;
    }

    function syncSizeTabStops() {
      pickers.forEach((picker) => {
        const radios = Array.from(picker.querySelectorAll('input[type="radio"]'));
        const hasChecked = radios.some((radio) => radio.checked);
        radios.forEach((radio, index) => {
          if (hasChecked) {
            radio.removeAttribute('tabindex');
          } else {
            radio.tabIndex = index === 0 ? 0 : -1;
          }
        });
      });
    }

    const buttons = [];
    forms.forEach((form) => {
      const btn = form.querySelector('.pdp__add-to-cart');
      const labelEl = btn?.querySelector('.pdp__add-to-cart-label');
      const priceEl = btn?.querySelector('.pdp__add-to-cart-price');
      if (!btn || !labelEl) return;

      const isMobileBar = mobileBar && mobileBar.contains(form);

      buttons.push({
        form,
        btn,
        labelEl,
        priceEl,
        isMobileBar,
        addLabel: form.getAttribute('data-add-to-cart-label') || 'Add to cart',
        selectSizeLabel: form.getAttribute('data-select-size-label') || 'Select size',
      });
    });

    let sizeClickLocked = false;
    let awaitingVariantUpdate = false;

    function showSelectSize(entry) {
      entry.labelEl.textContent = entry.selectSizeLabel;
      entry.btn.setAttribute('aria-label', entry.selectSizeLabel);
    }

    function showAddToCart(entry) {
      entry.labelEl.textContent = entry.addLabel;
      entry.btn.setAttribute('aria-label', entry.addLabel);
    }

    function needsSize(entry) {
      return entry.btn.hasAttribute('data-needs-size');
    }

    function updateAllButtons() {
      syncSizeTabStops();

      if (section.dataset.disableAddToCart === 'true') {
        const label = section.getAttribute('data-atc-disabled-label') || '';
        buttons.forEach((entry) => {
          entry.btn.removeAttribute('data-needs-size');
          entry.btn.removeAttribute('data-sheet-trigger');
          entry.labelEl.textContent = label;
          entry.btn.setAttribute('aria-label', label);
          entry.btn.disabled = true;
          if (entry.priceEl) entry.priceEl.hidden = false;
        });
        if (sheetSubmit && sheetLabelEl) {
          sheetLabelEl.textContent = label;
          sheetSubmit.setAttribute('aria-label', label);
          if (sheetPriceEl) sheetPriceEl.hidden = false;
          sheetSubmit.disabled = true;
        }
        return;
      }

      if (!pickers.length) return;

      const soldOutLabel = section.getAttribute('data-sold-out-label') || 'Sold out';

      if (section.dataset.productAvailable === 'false') {
        sizeClickLocked = false;
        buttons.forEach((entry) => {
          entry.btn.removeAttribute('data-needs-size');
          entry.btn.removeAttribute('data-sheet-trigger');
          entry.labelEl.textContent = soldOutLabel;
          entry.btn.setAttribute('aria-label', soldOutLabel);
          entry.btn.disabled = true;
          if (entry.priceEl) entry.priceEl.hidden = false;
        });
        if (sheetSubmit && sheetLabelEl) {
          sheetLabelEl.textContent = soldOutLabel;
          sheetSubmit.setAttribute('aria-label', soldOutLabel);
          if (sheetPriceEl) sheetPriceEl.hidden = false;
          sheetSubmit.disabled = true;
        }
        return;
      }

      const checked = getCheckedRadio();

      if (!checked) {
        sizeClickLocked = false;
        buttons.forEach((entry) => {
          if (entry.isMobileBar) {
            showSelectSize(entry);
            entry.btn.disabled = false;
            return;
          }
          entry.btn.setAttribute('data-needs-size', '');
          showAddToCart(entry);
          entry.btn.disabled = false;
        });

        if (sheetSubmit && sheetLabelEl) {
          const label = buttons[0]?.selectSizeLabel || 'Select size';
          sheetLabelEl.textContent = label;
          sheetSubmit.setAttribute('aria-label', label);
          if (sheetPriceEl) sheetPriceEl.hidden = true;
          sheetSubmit.disabled = true;
        }
        return;
      }

      const available = checked.dataset.optionAvailable !== 'false';

      buttons.forEach((entry) => {
        entry.btn.removeAttribute('data-needs-size');
        sizeClickLocked = false;
        const label = available ? entry.addLabel : soldOutLabel;
        entry.labelEl.textContent = label;
        entry.btn.setAttribute('aria-label', label);
        if (entry.priceEl) entry.priceEl.hidden = false;
        entry.btn.disabled = !available;
      });

      if (sheetSubmit && sheetLabelEl) {
        const sheetAddLabel = buttons[0]?.addLabel || 'Add to cart';
        const label = available ? sheetAddLabel : soldOutLabel;
        sheetLabelEl.textContent = label;
        sheetSubmit.setAttribute('aria-label', label);
        if (sheetPriceEl) sheetPriceEl.hidden = false;
        sheetSubmit.disabled = !available || awaitingVariantUpdate;
      }
    }

    if (pickers.length) {
      const productUnavailable = section.dataset.productAvailable === 'false';
      const requiresSizeChoice =
        section.querySelector('.pdp__add-to-cart[data-sheet-trigger]') !== null ||
        buttons.some(({ btn, isMobileBar }) => !isMobileBar && btn.hasAttribute('data-needs-size'));
      const pdpSizeRadios = section.querySelectorAll('.pdp-sizes__picker input[type="radio"]');
      const allPdpSizesOOS =
        pdpSizeRadios.length > 0 && Array.from(pdpSizeRadios).every((r) => r.dataset.optionAvailable === 'false');
      const shouldClearInitialSizeSelection = productUnavailable || allPdpSizesOOS || requiresSizeChoice;

      if (shouldClearInitialSizeSelection) {
        pickers.forEach((p) => {
          p.querySelectorAll('input[type="radio"]').forEach((radio) => {
            radio.checked = false;
            radio.dataset.currentChecked = 'false';
            radio.dataset.previousChecked = 'false';
          });
        });
        forms.forEach((form) => {
          const idInput = form.querySelector('input[name="id"]');
          if (idInput) idInput.value = '';
        });
      }

      pickers.forEach((p) => {
        p.addEventListener('change', () => {
          awaitingVariantUpdate = true;
          updateAllButtons();
        });
      });

      const sectionEl = section.closest('.shopify-section, dialog') || section;
      sectionEl.addEventListener('variant:update', () => {
        awaitingVariantUpdate = false;
        requestAnimationFrame(updateAllButtons);
      });

      updateAllButtons();
    }

    // How long the "Added!" success state stays on the button before reverting
    // to "Add to cart". Matches the user-perceived "you added something" beat.
    const ADDED_STATE_DURATION_MS = 4000;

    buttons.forEach((entry) => {
      const { btn, labelEl, priceEl, form, addLabel, isMobileBar } = entry;
      const addingLabel = form.getAttribute('data-adding-label') || 'Adding...';
      const addedLabel = form.getAttribute('data-added-label') || 'Added!';
      const formEl = form.querySelector('form[data-type="add-to-cart-form"]');

      // Resets variant pickers + hidden variant inputs to a clean slate after
      // a successful add — mirrors the existing flow, just hoisted so we can
      // run it on success (deferred) and on error (immediate).
      const clearVariantSelection = () => {
        pickers.forEach((p) => {
          p.querySelectorAll('input[type="radio"]').forEach((radio) => {
            radio.checked = false;
            radio.dataset.currentChecked = 'false';
          });
        });
        forms.forEach((f) => {
          const idInput = f.querySelector('input[name="id"]');
          if (idInput) idInput.value = '';
        });
      };

      const beginAdding = () => {
        labelEl.textContent = addingLabel;
        if (priceEl) priceEl.hidden = true;
        btn.setAttribute('aria-busy', 'true');
        btn.disabled = true;
        btn.classList.add('adding');
        btn.classList.remove('added');
      };

      if (!isMobileBar) {
        btn.addEventListener('mouseenter', () => {
          if (needsSize(entry) && !sizeClickLocked) showSelectSize(entry);
        });
        btn.addEventListener('mouseleave', () => {
          if (needsSize(entry) && !sizeClickLocked) showAddToCart(entry);
        });
        btn.addEventListener('focusin', () => {
          if (needsSize(entry) && !sizeClickLocked) showSelectSize(entry);
        });
        btn.addEventListener('focusout', () => {
          if (needsSize(entry) && !sizeClickLocked) showAddToCart(entry);
        });
      }

      if (isMobileBar && formEl) {
        formEl.addEventListener('submit', (e) => {
          if (btn.hasAttribute('data-sheet-trigger') && !getCheckedRadio()) {
            e.preventDefault();
            if (window.Alpine) Alpine.store('overlay').show('pdp-size-sheet');
            return;
          }
          if (needsSize(entry)) {
            e.preventDefault();
            return;
          }
          beginAdding();
        });
      } else if (formEl) {
        formEl.addEventListener('submit', (e) => {
          if (needsSize(entry)) {
            e.preventDefault();
            sizeClickLocked = true;
            showSelectSize(entry);
            return;
          }
          beginAdding();
        });
      }

      // Each entry owns its own "Added!" timeout so two ATC buttons on the
      // same page (main + mobile bar) don't clobber each other's reset.
      let addedTimeoutId = null;

      form.addEventListener('cart:update', (e) => {
        if (section.dataset.disableAddToCart === 'true') return;

        const didError = e?.detail?.data?.didError;

        btn.classList.remove('adding');
        btn.removeAttribute('aria-busy');

        if (didError) {
          // Failed add — revert to normal state immediately so the user can retry.
          btn.classList.remove('added');
          btn.disabled = false;
          if (priceEl) priceEl.hidden = false;
          clearVariantSelection();
          updateAllButtons();
          return;
        }

        // Success — show "Added!" for ADDED_STATE_DURATION_MS, then revert.
        // Button stays disabled and price stays hidden during this window so
        // the success state reads as a deliberate confirmation, not an idle
        // button. Pickers are NOT cleared yet — keeping the selected size
        // visible reinforces what was added. Both reset together on timeout.
        btn.classList.add('added');
        labelEl.textContent = addedLabel;

        if (addedTimeoutId) clearTimeout(addedTimeoutId);
        addedTimeoutId = setTimeout(() => {
          addedTimeoutId = null;
          btn.classList.remove('added');
          btn.disabled = false;
          if (priceEl) priceEl.hidden = false;
          clearVariantSelection();
          updateAllButtons();
        }, ADDED_STATE_DURATION_MS);
      });

      // Notify me (reinstate): on click when data-notify-action, prevent default and dispatch notify-me-open.
    });

    if (sheetSubmit) {
      const mobileForm = document.getElementById('pdp-mobile-add-to-cart-form');

      const mobileFormComponent = mobileForm?.closest('product-form-component');
      const sheetAddedLabel = buttons[0]?.form.getAttribute('data-added-label') || 'Added!';

      sheetSubmit.addEventListener('click', () => {
        if (sheetSubmit.disabled) return;

        // Notify me (reinstate): if data-notify-action, hide overlay and dispatch notify-me-open.

        const variantInput = mobileForm?.querySelector('input[name="id"]');
        if (!variantInput?.value) return;

        const addingLabel = buttons[0]?.form.getAttribute('data-adding-label') || 'Adding...';
        sheetLabelEl.textContent = addingLabel;
        if (sheetPriceEl) sheetPriceEl.hidden = true;
        sheetSubmit.setAttribute('aria-busy', 'true');
        sheetSubmit.disabled = true;
        sheetSubmit.classList.add('adding');
        sheetSubmit.classList.remove('added');

        if (mobileForm) mobileForm.requestSubmit();
      });

      if (mobileFormComponent) {
        let sheetAddedTimeoutId = null;

        const resetSheetButton = () => {
          if (sheetAddedTimeoutId) {
            clearTimeout(sheetAddedTimeoutId);
            sheetAddedTimeoutId = null;
          }
          sheetSubmit.classList.remove('adding', 'added');
          sheetSubmit.removeAttribute('aria-busy');
          sheetSubmit.disabled = false;
          if (sheetPriceEl) sheetPriceEl.hidden = false;
          updateAllButtons();
        };

        mobileFormComponent.addEventListener('cart:update', (e) => {
          if (e.detail?.data?.didError) {
            resetSheetButton();
            return;
          }
          // Success — flash "Added!" briefly on the sheet button before the
          // overlay hides. The main mobile-bar / desktop button keeps its own
          // 3s "Added!" state in parallel (per-entry handler above), so the
          // user still sees the confirmation after the sheet closes.
          sheetSubmit.classList.remove('adding');
          sheetSubmit.classList.add('added');
          sheetSubmit.removeAttribute('aria-busy');
          sheetSubmit.disabled = true;
          sheetLabelEl.textContent = sheetAddedLabel;

          if (sheetAddedTimeoutId) clearTimeout(sheetAddedTimeoutId);
          sheetAddedTimeoutId = setTimeout(() => {
            sheetAddedTimeoutId = null;
            sheetSubmit.classList.remove('added');
            sheetSubmit.disabled = false;
            if (sheetPriceEl) sheetPriceEl.hidden = false;
            updateAllButtons();
            if (window.Alpine) Alpine.store('overlay').hide();
          }, ADDED_STATE_DURATION_MS);
        });

        mobileFormComponent.addEventListener('cart:error', resetSheetButton);
      }
    }

    if (mobileBar) {
      const footer = document.querySelector('.shopify-section-group-footer-group, footer, .footer-content');
      if (footer) {
        const observer = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) {
              mobileBar.style.transform = 'translateY(100%)';
            } else {
              mobileBar.style.transform = '';
            }
          },
          { threshold: 0 },
        );
        observer.observe(footer);
      }
    }
  }

  function initPdpDesktopGallery() {
    const gallery = document.querySelector('[data-desktop-gallery]');
    if (!gallery) return;

    const scrollEl = gallery.querySelector('[data-gallery-scroll]');
    if (!scrollEl) return;

    const items = Array.from(scrollEl.querySelectorAll('.pdp__gallery-scroll-item'));
    const list = gallery.querySelector('.pdp__gallery-thumbs-list');
    const thumbs = Array.from(gallery.querySelectorAll('[data-gallery-thumb-index]'));
    if (!items.length || !thumbs.length || !list) return;

    /*
      Index of the item nearest the scroll viewport's vertical centre. Mirrors
      getDesktopGalleryScrollIndex() in src/pdp-zoom-dialog.js so the image the
      zoom dialog opens on is always one of the highlighted thumbnails. Two
      half-width items share a row and therefore tie on distance — the strict
      `>` comparison keeps the left one, and getRowIndices() widens that back
      out to the whole row.
    */
    function getActiveIndex() {
      const rootRect = scrollEl.getBoundingClientRect();
      const centerY = rootRect.top + rootRect.height / 2;
      let best = 0;
      let bestScore = -Infinity;
      items.forEach((el, i) => {
        const rect = el.getBoundingClientRect();
        const mid = rect.top + rect.height / 2;
        const inside = centerY >= rect.top && centerY <= rect.bottom ? 1 : 0;
        const score = inside * 1e9 - Math.abs(mid - centerY);
        if (score > bestScore) {
          bestScore = score;
          best = i;
        }
      });
      return best;
    }

    // Every item sharing a row with `index`. A pair of half-width images is
    // equally on screen, so the rail highlights both rather than picking one.
    function getRowIndices(index) {
      const target = items[index];
      if (!target) return [index];
      const top = target.getBoundingClientRect().top;
      const row = [];
      items.forEach((el, i) => {
        if (Math.abs(el.getBoundingClientRect().top - top) <= 1) row.push(i);
      });
      return row;
    }

    // Nudge the rail's own scroll only — scrollIntoView() would also scroll the
    // gallery and page ancestors, fighting the scroll that triggered this.
    function revealThumb(btn) {
      if (list.scrollHeight <= list.clientHeight) return;
      const listRect = list.getBoundingClientRect();
      const btnRect = btn.getBoundingClientRect();
      if (btnRect.top < listRect.top) {
        list.scrollTop -= listRect.top - btnRect.top;
      } else if (btnRect.bottom > listRect.bottom) {
        list.scrollTop += btnRect.bottom - listRect.bottom;
      }
    }

    let activeRowKey = '';
    function syncThumbs() {
      const row = getRowIndices(getActiveIndex());
      const rowKey = row.join(',');
      if (rowKey === activeRowKey) return;
      activeRowKey = rowKey;

      const active = new Set(row);
      thumbs.forEach((btn, i) => {
        const isActive = active.has(i);
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-current', isActive ? 'true' : 'false');
      });

      // Reveal the far end first so the near end wins if the row can't fit.
      const last = thumbs[row[row.length - 1]];
      const first = thumbs[row[0]];
      if (last) revealThumb(last);
      if (first) revealThumb(first);
    }

    let frame = 0;
    function scheduleSync() {
      if (frame) return;
      frame = requestAnimationFrame(() => {
        frame = 0;
        syncThumbs();
      });
    }

    thumbs.forEach((btn, i) => {
      btn.addEventListener('click', () => {
        const target = items[i];
        if (!target) return;
        const top = scrollEl.scrollTop + target.getBoundingClientRect().top - scrollEl.getBoundingClientRect().top;
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        scrollEl.scrollTo({ top, behavior: reduceMotion ? 'auto' : 'smooth' });
      });
    });

    scrollEl.addEventListener('scroll', scheduleSync, { passive: true });
    window.addEventListener('resize', scheduleSync, { passive: true });
    syncThumbs();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initPdpBuybox();
      initPdpDesktopGallery();
    });
  } else {
    initPdpBuybox();
    initPdpDesktopGallery();
  }

  } catch(e) { console.error(e); }
})();
})();
